import React from 'react';
import './area-button.scss';
import PropTypes from 'prop-types';

const AreaButton = ({ isComplete = false, isSelected = false, areaButtonId, name, onClick, scenarioId }) => {
	return (
		<div className={'AreaButton' + (isSelected ? ' selected' : '')} onClick={() => {if (onClick) onClick();}}>
			<div className={'AreaButton-circle ' + scenarioId}>
				<div className={'AreaButton-icon ' + areaButtonId + ' ' + scenarioId}/>
			</div>
			<div className='AreaButton-barWrapper'>
				<div className={'AreaButton-bottomBar ' + scenarioId + ' ' + areaButtonId}/>
				<div className={'AreaButton-bar ' + scenarioId + ' ' + areaButtonId}>
					<span>{name}</span>
				</div>
			</div>
			{isComplete && 
				<div className='AreaButton-complete'/>
			}
		</div>
	);
};

AreaButton.propTypes = {
	isComplete: PropTypes.bool,
	isSelected: PropTypes.bool,
	areaButtonId: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	scenarioId: PropTypes.string.isRequired,
};

export default AreaButton;